import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"
import _imports_0 from './images/bg.png'


const _hoisted_1 = { class: "customs-clearance" }
const _hoisted_2 = { class: "btns" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "number" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, "总量：", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, "TEU", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "lines" }, [
  /*#__PURE__*/_createElementVNode("span", null, [
    /*#__PURE__*/_createElementVNode("i")
  ]),
  /*#__PURE__*/_createElementVNode("span", null, [
    /*#__PURE__*/_createElementVNode("i")
  ]),
  /*#__PURE__*/_createElementVNode("span", null, [
    /*#__PURE__*/_createElementVNode("i")
  ])
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)

export function render(_ctx, _cache) {
  const _component_MiniTitle = _resolveComponent("MiniTitle")
  const _component_item = _resolveComponent("item")

  return (_openBlock(), _createBlock(_component_item, { title: "报关通关操作量" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_MiniTitle, { title: "通关量" }),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("ul", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data, (item, index) => {
              return (_openBlock(), _createElementBlock("li", {
                class: _normalizeClass({active: _ctx.type === item.clearanceName}),
                onClick: $event => (_ctx.type = item.clearanceName),
                key: item.clearanceName + index
              }, _toDisplayString(item.clearanceName), 11, _hoisted_3))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h3", null, [
            _hoisted_5,
            _createElementVNode("span", null, _toDisplayString(_ctx.data[_ctx.type] ? _ctx.data[_ctx.type].teuNum : 0), 1),
            _hoisted_6
          ]),
          _hoisted_7,
          _hoisted_8
        ])
      ])
    ]),
    _: 1
  }))
}